<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      :formInputs="formInputs"
      primaryKey="id"
    >
      <template v-slot:modo_rateio="{model}">
        <span :class="+model.modo_rateio ? 'badge badge-success' : 'badge badge-secondary'">
          {{ labelModoRateio(model.modo_rateio) }}
        </span>
      </template>
    </crud-base>

</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
import { schemaReadOnly, schemaSelect } from "@/helpers/form";

const MODOS_RATEIO = {
  0: "Não rateia",
  1: "Rateia no custo",
  2: "Rateia no valor de venda",
};

export default {
  name: "TiposFrete",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-frete",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false },
        { label: "RATEIO DE FRETE", field: "modo_rateio", sortable: false }
      ],
      formInputs: {
        id: schemaReadOnly("Cód.", 3),
        descricao: schemaReadOnly("Descrição", 9),
        modo_rateio: schemaSelect("Rateio de frete", true, 6, MODOS_RATEIO, "0"),
      },
    };
  },
  methods: {
    labelModoRateio(modo) {
      return MODOS_RATEIO[+modo] ?? MODOS_RATEIO[0];
    },
  },
};
</script>
